export enum CONSTANTS {
  DELETE = "delete",
  MODIFIED = "modified",
  NOCHANGE = "noChange",
  UPDATE = "update",
  CREATE = "create",
  COLORHEX = "#e1e1e1",
  COLORWHITE = "#F5F5F5",
  TABLE = "table",
  OKAY = "OK",
  SOLIDRED = "2px solid red",
  SOLIDGREEN = "1px solid green",
  SOLIDORANGE = "1px solid orange",
  ENG = "eng",
  WHITE = "#fff"
}

